<template>
  <div class="listing-form video-information margin-auto">
    <Card class="video-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-videocam"/>
        <div><p style="color:#000;font-weight:bold">Video</p></div>
      </div>
      <div>
        <Form label-position="top">
          <FormItem label="Video about your company or solution (YouTube)" prop="video_url">
            <Input v-model="value.video_url" class="k-input"/>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      formData: {
        name: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-information {
  max-width:700px;
  .video-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.video-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
